import { VisitOption, Category } from "src/common/types/visit";
import { Representative } from "../types/representative";

export const sortVisitOptions = (visitOptions: VisitOption[]): VisitOption[] => {
  visitOptions.forEach(v => {
    sortReasons(v as Category);
  });

  return visitOptions.sort(visitCompareFn);
};

export const mapRepToVisitOption = (r: Representative, showBranchInfo: boolean) => {
  return {
    id: r.id,
    description: showBranchInfo
      ? r.branches
          .filter(b => !b.isVirtual)
          .map(b => b.name)
          .join(", ")
      : r.description,
    secondaryDescription: showBranchInfo ? r.description : undefined,
    name: r.name,
    imageUrl: r.imageUrl,
    thumbnailUrl: r.thumbnailUrl,
    appointmentsEnabled: true,
    membersOnly: false,
    serviceRepOnly: false
  } as VisitOption;
};

const sortReasons = (category: Category) => {
  if (category.reasons && category.reasons.length > 0) {
    category.reasons.sort(visitCompareFn);
  }
};

const visitCompareFn = (a: VisitOption, b: VisitOption) => {
  if (a.name.toLowerCase() < b.name.toLowerCase()) {
    return -1;
  } else if (b.name.toLowerCase() < a.name.toLowerCase()) {
    return 1;
  } else {
    return 0;
  }
};
